import firebase from 'firebase/app';
import 'firebase/firestore';

firebase.initializeApp({
    apiKey: "AIzaSyADMWAXJFu3XO8nPnk6iSFHB2NoI8-ikt0",
    authDomain: "prayforme-6a774.firebaseapp.com",
    databaseURL: "https://prayforme-6a774.firebaseio.com",
    projectId: "prayforme-6a774",
    storageBucket: "prayforme-6a774.appspot.com",
    messagingSenderId: "395481621142"
});

export const db = firebase.firestore();
db.settings({timestampsInSnapshots: true});